import React, { useEffect, useState } from "react";
import projectImg from "../../assets/img/project-img.png";
import ToolBar from "../common-web/ToolBar";
import FdBottomDrawer from "./FdBottomDrawer";
import { XAxisDrawerIcon } from "../../Icons";
import loader from "../../assets/img/loader.gif";
import ResizableBox from "../common/ResizeableBox";

export default function FdViewerContent({ setIsOpenSearchResult }) {
  const [isShowDrawer, setIsShowDrawer] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading for 5 seconds
    const timer = setTimeout(() => setLoading(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col flex-1 relative h-[calc(100vh-50px)] bg-white">
      {/* Toolbar */}
      <ToolBar />

      {/* Main Content */}
      <div className="flex-1  flex items-center justify-center overflow-hidden">
        {loading ? (
          <div>
            <img src={loader} alt="Loading..." className="max-w-[140px]" />
          </div>
        ) : (
          <img
            src={projectImg}
            alt="Project"
            className="h-full w-full object-cover"
          />
        )}
      </div>

      {/* Drawer Section */}
      {isShowDrawer ? (
        <div className="bg-white border-t border-gray-200">
          <ResizableBox
            direction="vertical"
            initialSize={425}
            minSize={35}
            maxSize={500}
            resize_handle_position="top"
          >
            <FdBottomDrawer
              setIsShowDrawer={setIsShowDrawer}
              setIsOpenSearchResult={setIsOpenSearchResult}
            />
          </ResizableBox>
        </div>
      ) : (
        <button
          onClick={() => setIsShowDrawer(true)}
          className="absolute top-1/2 right-0 -translate-y-1/2 bg-white sm:pl-5 pl-3 pr-2.5 py-[5px] flex items-center sm:gap-6 gap-3 border border-gray-200 rounded-l-md shadow-md"
        >
          <span className="hidden sm:block text-[#242424] text-[12px] font-bold">
            4D
          </span>
          <XAxisDrawerIcon />
        </button>
      )}
    </div>
  );
}
